module.exports = __webpack_public_path__ + "static/img/3101_phase_function_Paper_PointsHejduk_Prediction.c3262e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3101_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 1Nxx
// module chunks = 0